// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1PZ-d","clinicsSelect":"TableHeading_clinicsSelect__2-RIN"};